export const filters = {
    includes:
        <Key extends string>(...keys: Key[]) =>
        <T extends Record<Key, string | undefined>>(
            items: T[],
            query: string,
        ) =>
            items.filter((item) =>
                keys.some((key) =>
                    item[key]?.toLowerCase().includes(query.toLowerCase()),
                ),
            ),
};
